import { createGlobalStyle } from 'styled-components';
import { ThemeInterface } from '../../interfaces';
import reset from 'styled-reset';
const GlobalStyle = createGlobalStyle`
	${reset}
	body {
			background-color: ${({ theme }) => theme.background};
			*,
			*::after,
			*::before {
				box-sizing: border-box;
			}
			margin: 0;
			padding: 0;
			font-family: 'Solway', serif;
			font-weight: ${({ theme }: { theme: ThemeInterface }) => theme.fontWeight.regular};
			color: ${({ theme }: { theme: ThemeInterface }) => theme.text};
		
	}
	::selection {
		background-color: ${({ theme }: { theme: ThemeInterface }) => theme.secondary};
	}
	* {
		transition: background .1s linear;
	}
`;

export { GlobalStyle };
